/**
 * Atmosphere — Susurro's serene backdrop.
 *
 * Soft, diffuse orbs (periwinkle/teal halo) that "breathe" very slowly
 * behind the content, giving the calm feel of a private conversation.
 * Theme-aware via the --glow-0/1/2 tokens (much more present in dark
 * mode, the star). Purely decorative (aria-hidden), it does not intercept the
 * pointer and its movement is neutralized by the global reduced-motion guard.
 */

import type { JSX } from "solid-js";

export function Atmosphere(): JSX.Element {
  return (
    <div
      aria-hidden="true"
      class="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
      style={{ "background-color": "var(--background)" }}
    >
      <div
        class="animate-float absolute -top-24 -left-24 h-[42vh] w-[42vh] rounded-full blur-3xl"
        style={{
          background: "radial-gradient(closest-side, var(--glow-0), transparent)",
        }}
      />
      <div
        class="animate-float absolute top-1/3 -right-28 h-[46vh] w-[46vh] rounded-full blur-3xl"
        style={{
          background: "radial-gradient(closest-side, var(--glow-1), transparent)",
          "animation-delay": "-1.2s",
        }}
      />
      <div
        class="animate-float absolute -bottom-28 left-1/4 h-[38vh] w-[38vh] rounded-full blur-3xl"
        style={{
          background: "radial-gradient(closest-side, var(--glow-2), transparent)",
          "animation-delay": "-2.4s",
        }}
      />
    </div>
  );
}
